import TagManager from 'react-gtm-module'

import { ACCESS_TYPE, NAVIGATION_TYPES, USER_ROLE_TYPES } from 'utils/constants/constants'

const GoogleTagManager = {
  initializeFromUserBook(userBook) {
    const currentUserBook = userBook?.userBook
    const accessType = currentUserBook?.accessType ?? ACCESS_TYPE.premium
    const userRole = currentUserBook?.user?.role ?? USER_ROLE_TYPES.student

    TagManager.initialize({
      dataLayer: {
        licenseType: accessType,
        navigationType: NAVIGATION_TYPES.open20,
        userRole,
      },
      gtmId: process.env.REACT_APP_GTM_CODE,
    })
  },
  trackSection(section) {
    TagManager.dataLayer({
      dataLayer: {
        section,
      },
    })
  },
}

export default GoogleTagManager
